/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'

// Components
import ImageBackground from 'components/shared/ImageBackground'
import ParseContent from 'components/shared/ParseContent'
import CustomLink from 'components/shared/CustomLink'
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'

// Elements
import OtherNews from 'components/elements/OtherNews'
import ButtonDefault from 'components/elements/ButtonDefault'

// Third Party
import styled, { css } from 'styled-components'
import { FaEnvelope, FaFacebookF, FaWhatsapp, FaLinkedinIn, FaTwitter } from 'react-icons/fa'
import { EmailShareButton, FacebookShareButton, WhatsappShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share'

// Images
import ArrowIcon from 'img/icon-left-white.svg'

const Hero = styled(ImageBackground)`
  height: 700px;
`

const Box = styled.div`
  background: white;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  font-size: ${(props) => props.theme.font.size.m};
  line-height: ${(props) => props.theme.font.size.xl};
  font-family: ${(props) => props.theme.font.family.main};
  color: ${(props) => props.theme.color.text.main};
  padding: 50px 70px 50px 70px;

  ${props => props.length >= 40 && css`
    h4 {
      font-size: ${props => props.theme.font.size.xxl} !important;
      line-height: ${props => props.theme.font.size.xxl} !important;

      @media screen and (max-width: 992px) {
        font-size: ${(props) => props.theme.font.size.l};
        line-height: ${(props) => props.theme.font.size.l};
      }
    }
  `}

  ${props => console.log(props.length)}

  h2 {
    padding-top: 10px;
    font-size: ${(props) => props.theme.font.size.xl};
    line-height: ${(props) => props.theme.font.size.xl};
    font-family: ${(props) => props.theme.font.family.secondary};
    text-transform: uppercase;
  }

  h4 {
    font-size: ${(props) => props.theme.font.size.xxxl};
    line-height: ${(props) => props.theme.font.size.xxxl};
    font-family: ${(props) => props.theme.font.family.secondary};
    text-transform: uppercase;
    @media screen and (max-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xl};
      line-height: ${(props) => props.theme.font.size.xl};
    }
  }

  @media screen and (max-width: 991px) {
    padding: 20px 30px 20px 30px;
  }
`
const RedLine = styled.div`
  width: 80%;
  border-bottom: 5px solid ${(props) => props.theme.color.face.main};
  position: absolute;
  left: 15px;
`
const Name = styled.div`
  font-size: ${(props) => props.theme.font.size.xm};
  line-height: ${(props) => props.theme.font.size.xl};
  font-family: ${(props) => props.theme.font.family.main};
  color: ${(props) => props.theme.color.face.main};
`
const SocialIcon = styled.a`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: ${(props) => props.theme.color.text.main};
  display: flex;
  justify-content: center;
  padding-top: 10px;
  cursor: pointer;
`
const Back = styled(CustomLink)`
  color: ${(props) => props.theme.color.text.light};
  &:hover {
    color: ${(props) => props.theme.color.text.light};
  }
`
const Main = styled.div`
  position: relative;
  margin-top: -400px;

  @media screen and (max-width: 991px) {
    margin-top: -600px;
  }
`

const Title = styled.h2`
  font-family: ${props => props.theme.font.family.secondary};
  font-size: ${props => props.theme.font.size.xxml};
  margin-bottom: 20px;
  position: relative;

  @media screen and (max-width: 576px) {
    padding-bottom: 30px;
    font-size: ${props => props.theme.font.size.xxl};
  }

  &::before {
    content: "";
    position: absolute;
    right: -1350px;
    width: 2000px;
    height: 5px;
    bottom: 20px;
    background-color: ${props => props.theme.color.face.main};

    @media screen and (max-width: 1199px) {
      right: -1520px;
    }

    @media screen and (max-width: 991px) {
      right: -1770px;
    }

    @media screen and (max-width: 768px) {
      right: -1950px;
    }


    @media screen and (max-width: 576px) {
      right: -1000px;
    }
  }
`

const PostTemplate = ({
  data: {
    page: { path, title, yoast_meta: yoast, acf },
  },
  location
}) => {
  return (
    <Layout activePage={'/nieuws/'}>
      <SEO
        yoast={yoast}
        path={path}
        image={{ url: acf.banner.image.localFile && acf.banner.image.localFile.childImageSharp.openGraph.src }}
        type="article"
      />

      <Hero src={acf.banner.image} />

      <Main className="container d-flex justify-content-center">
        <div className="col-lg-12">
          <Back className="px-3 px-lg-5 d-flex mb-4" to="/nieuws/">
            <img src={ArrowIcon} alt="arrow" />
            <span className="ml-3 font-weight-xl">Terug naar blogoverzicht</span>
          </Back>
          <Box length={title.length} className="w-100">
            <h4 className="pt-lg-5 pt-3 px-2 px-lg-5 pb-3">
              {title}
            </h4>
            <RedLine />
            <ParseContent className="my-3 my-lg-5 pt-5 px-1 px-lg-5" content={acf.story.description} />
            <div className="d-flex justify-content-center justify-content-lg-end px-1 py-5 p-lg-5">
              <div>
                <Name className="text-lg-left text-center">Deel dit bericht</Name>
                <div className="d-flex mt-3">
                  <EmailShareButton url={location.href}>
                    <SocialIcon className="mr-2">
                      <FaEnvelope size={24} color="white" />
                    </SocialIcon>
                  </EmailShareButton>

                  <FacebookShareButton url={location.href}>
                    <SocialIcon className="mr-2">
                      <FaFacebookF size={24} color="white" />
                    </SocialIcon>
                  </FacebookShareButton>

                  <WhatsappShareButton url={location.href}>
                    <SocialIcon className="mr-2">
                      <FaWhatsapp size={24} color="white" />
                    </SocialIcon>
                  </WhatsappShareButton>

                  <LinkedinShareButton url={location.href}>
                    <SocialIcon className="mr-2">
                      <FaLinkedinIn size={24} color="white" />
                    </SocialIcon>
                  </LinkedinShareButton>

                  <TwitterShareButton url={location.href}>
                    <SocialIcon>
                      <FaTwitter size={24} color="white" />
                    </SocialIcon>
                  </TwitterShareButton>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Main>
      <div className="d-flex justify-content-center my-5 py-5">
        <ButtonDefault to="/nieuws" type="outline">
          <p className="mb-0 font-weight-xl">Terug naar blogoverzicht</p>
        </ButtonDefault>
      </div>

      <div className="container pt-lg-0 pt-5">
        <Title>ANDER NIEUWS</Title>
      </div>

      <OtherNews className="pb-lg-5 pb-3" />

    </Layout>
  )
}

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressPost(wordpress_id: { eq: $wordpress_id }) {
      ...NewsFrag
    }
  }
`

export default PostTemplate